import React from 'react';

interface MicrophoneMeterProps {
  level: number; // 0 to 100
  isActive?: boolean;
}

export const MicrophoneMeter: React.FC<MicrophoneMeterProps> = ({ level, isActive = true }) => {
  const clampedLevel = Math.max(0, Math.min(100, Math.round(level)));

  const getMeterColor = (val: number) => {
    if (val > 80) return '#FBBF24';  // amber
    if (val > 5)  return '#10B981';  // green
    return '#334155';                // slate
  };

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '12px' }}>
        <span style={{ color: '#94A3B8', fontWeight: 500 }}>Input Signal:</span>
        <span style={{ fontFamily: 'monospace', fontWeight: 600, color: '#CBD5E1' }}>
          {isActive ? `${clampedLevel}%` : 'Inactive'}
        </span>
      </div>

      <div
        role="progressbar"
        aria-valuenow={clampedLevel}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Microphone input level"
        style={{
          height: '10px',
          width: '100%',
          overflow: 'hidden',
          borderRadius: '20px',
          background: '#1E293B',
          border: '1px solid rgba(255,255,255,0.06)',
          padding: '2px',
        }}
      >
        <div
          style={{
            height: '100%',
            borderRadius: '20px',
            background: getMeterColor(clampedLevel),
            width: `${isActive ? clampedLevel : 0}%`,
            transition: 'width 75ms ease-out',
            boxShadow: clampedLevel > 5 ? `0 0 6px ${getMeterColor(clampedLevel)}80` : 'none',
          }}
        />
      </div>
    </div>
  );
};
